module.exports = __webpack_public_path__ + "img/7.6ed6cd51.png";